{
  "lastUpdatedAt": "2026-06-16T14:19:08.918Z",
  "lastFetchAttemptAt": "2026-06-16T14:19:08.918Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}